import React from 'react';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import styles from './HelpButton.module.css';

interface HelpButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** The explanation is showing (a second tap hides it). */
  expanded?: boolean;
  className?: string;
}

/** The "?" next to Play and Slower: what did the character just say? */
export const HelpButton: React.FC<HelpButtonProps> = ({
  onClick,
  disabled = false,
  expanded = false,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-expanded={expanded}
    className={`${styles.helpButton} ${className || ''}`}
    aria-label={INTERFACE_TEXT.helpButtonLabel}
  >
    {INTERFACE_TEXT.helpButtonText}
  </button>
);

export default HelpButton;
